import * as queryStringHelper from 'query-string';

export const getImageIdFromThumbnailId = (image) => {
	return queryStringHelper.parse(image?.webSearchUrl?.split('?')[1])?.id;
};
